module.exports = __webpack_public_path__ + "static/media/Frame 3.10bc4319.svg";